export default __webpack_public_path__ + "static/media/logo.f7b23ea7.png";